// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"333":"923129c245f749f7","778":"cdd187b8d7a15684"}[chunkId] + ".js";
};